module.exports = __webpack_public_path__ + "img/c8.11a4e9b6.png";